import React, {Component} from 'react';
import {LocalPostOffice} from '@mui/icons-material';
import {CircularProgress, IconButton, Popover, Tooltip} from '@mui/material';
import {connect} from 'react-redux';

import {getAllSMSHistory, getMessageText} from '../../actions/smsHistory';
import Table from '../../components/Table';
import {GAEventTracker} from '../../lib/googleAnalytics';
import {dateFormat, formatTimestampMs} from '../../lib/utils';

const langMap = {failed : 'Failed', done : 'Delivered', pending : 'Pending', DELIVRD : 'Delivered', INVALID : 'Invalid', visited: 'Visited'};
const DEFAULT_PAGE_SIZE = 50;
const DEFAULT_DATE_RANGE_DAYS = 30; // Default to last 30 days

class AllSMSHistory extends Component {
  constructor(props){
    super(props);
    this.state = {
      smsList : [],
      showWait : false,
      anchorEl: null,
      showTrackData: false,
      smsText: '',
      currentPage: 0,
      pageSize: DEFAULT_PAGE_SIZE,
      totalCount: 0,
      loading: false
    }
    this.receiveShowMessage = true;
  }

  componentDidMount(){
    this.fetchMessages(1, DEFAULT_PAGE_SIZE);
  }

  getDefaultDateRange = () => {
    const now = Date.now();
    const daysAgo = DEFAULT_DATE_RANGE_DAYS * 24 * 60 * 60 * 1000;
    return {
      start_date: now - daysAgo,
      end_date: now
    };
  }

  fetchMessages = (page, pageSize) => {
    this.setState({loading: true});
    this.props.getAllSMSHistory({
      page,
      page_size: pageSize,
      date_range: this.getDefaultDateRange()
    });
  }

  componentWillReceiveProps(nextProps){
    let {smsHistoryList, trackCampaignRes} = nextProps;
    if(this.state.loading && smsHistoryList){
      if(smsHistoryList.success){
        const pagination = smsHistoryList.data.pagination || {};
        this.setState({
          smsList: smsHistoryList.data.list || [],
          totalCount: pagination.totalItems || 0,
          currentPage: (pagination.page || 1) - 1, // Convert to 0-based
          pageSize: pagination.pageSize || DEFAULT_PAGE_SIZE,
          loading: false
        });
      } else if(smsHistoryList.err){
        alert(smsHistoryList.err.msg);
        this.setState({loading: false});
      } else{
        alert("Something went wrong!");
        this.setState({loading: false});
      }
    }
    if (!this.receiveShowMessage && trackCampaignRes) {
      if (trackCampaignRes.success) {
        this.receiveShowMessage = true;
        this.setState({smsText: trackCampaignRes.smsText, showTrackData: true});
      } else if (trackCampaignRes.err) {
        alert(trackCampaignRes.err.msg);
        this.receiveShowMessage = true;
        this.setState({showTrackData: false, anchorEl: null});
      } else {
        alert("Something went wrong!");
        window.location.reload();
      }
    }
  }

  handlePageChange = (newPage, pageSize) => {
    this.fetchMessages(newPage + 1, pageSize); // Convert to 1-based for API
  }

  handlePageSizeChange = (page, newPageSize) => {
    this.fetchMessages(1, newPageSize); // Reset to page 1 when changing page size
  }

  showMessage = (event, data) => {
    event.preventDefault();
    event.stopPropagation()
    this.receiveShowMessage = false;
    if (data.messageText) {
      this.setState({anchorEl: event.currentTarget, showTrackData: true, smsText: data.messageText});
    } else {
      this.setState({anchorEl: event.currentTarget, showTrackData: false});
      this.props.getMessageText(data.campaignId, data.messageId);
    }
    GAEventTracker({category: 'SMS-History', action: 'Show Track Campaign'});
  }

  closeTrackCampaign = () => this.setState({anchorEl: null, showTrackData: false, smsText: ''});

  render() {
    let {smsList, showTrackData, anchorEl, smsText, loading, currentPage, pageSize, totalCount} = this.state;
    const isMobile = window.isMobile();
    return (
      <div className='sms-parent-container' style={isMobile ? {padding: 8} : {}}>
        {loading ? (
          <div style={{display: 'flex', justifyContent: 'center', padding: 50}}>
            <CircularProgress size={80} thickness={5} />
          </div>
        ) : smsList.length ? (
          <Table
            column={[
              {name: 'Service', value: 'messageType', cell: (val, row) => val || row.smstype || '--'},
              {name: 'Mobile/Sender', value: 'phoneNumber', cell: (val, row) => (<>{val || row.mobile} <p style={{fontSize:10, marginTop: 3, color: '#3b3d3e'}}>{row.senderId}</p></>)},
              {name: 'Sent At', value: 'createdAt', cell: (val) => formatTimestampMs(val)},
              {name: 'Updated At', value: 'deliveredAt', cell: (val, row) => { const v = (val && val !== '0') ? val : ((row.failedAt && row.failedAt !== '0') ? row.failedAt : ((row.sentAt && row.sentAt !== '0') ? row.sentAt : ((row.updatedAt && row.updatedAt !== '0') ? row.updatedAt : row.createdAt))); return formatTimestampMs(v); }},
              {name: 'Status', value: 'clientStatus', cell: (val, row) => val || row.statusCode || row.status || '--'},
              {name: 'Message', value: 'messageText', cell: (val, row) => (
                <Tooltip title="View Message">
                  <IconButton aria-label='show' onClick={e => {this.showMessage(e, row)}}><LocalPostOffice /></IconButton>
                </Tooltip>)}
            ]}
            data={smsList}
            showPagination
            serialNumber
            serverSidePagination
            totalCount={totalCount}
            currentPage={currentPage}
            defaultPageSize={pageSize}
            onPageChange={this.handlePageChange}
            onPageSizeChange={this.handlePageSizeChange}
          />
        ) : (
          <p style={{padding: 50, fontSize: 16, color: '#333'}}>Currently No Sent Messages Available, Please do send your first SMS!</p>
        )}
        {Boolean(anchorEl) && <Popover
          open
          anchorEl={anchorEl}
          anchorOrigin={{horizontal: 'left', vertical: 'top'}}
          transformOrigin={{horizontal: 'right', vertical: 'bottom'}}
          onClose={this.closeTrackCampaign}
          disableScrollLock
        >
          {
            showTrackData ?
              <div style={{padding: '16px 24px', width: 300}}>
                <p style={{fontSize: 16, paddingBottom: 10, fontWeight: 500, marginBottom: 5, borderBottom: '1px solid #d4d4d3'}}>Message</p>
                <p style={{paddingTop: 10, fontSize: 14}}>{smsText}</p>
              </div>
              : <CircularProgress />
          }

        </Popover>
        }
      </div>
    )
  }
}
function mapStateToProps(state){
  return {
    smsHistoryList: state.smsHistory.getAllHistoryResponse,
    trackCampaignRes: state.smsHistory.getTrackCampaignResponse
  };
}
export default connect(mapStateToProps, {getAllSMSHistory, getMessageText})(AllSMSHistory);
